import { Service } from "models/Service";

export class DrawFifaWorldCup extends Service {
  constructor() {
    super({
      adsPath: "clarin/pronostico-mundial-26/home",
      meta: {
        description: `Pronóstico mundial 2026 - Clarin.com`,
        keywords: '',
        title: `Pronóstico mundial 2026 - Clarin.com`,
        url: `pronostico-mundial-2026`, 
        extra: [],
      },
      section: "deportes",
      sectionName: "Deportes",
      template: "DrawFifaWorldCup",
      title: `Pronóstico mundial 2026`,
      slug: "",
      titleHeader:false,
      widthFull: true,
      //bannersOn: false,
      enableHeader: true,
      enableFooter: true,
      autorefresh: false,
      bannerFlotanteOff: ["6"],
      bannerHorizontalOff: ["horizontal3"],
      showLiveblog: false,
      showNewsToday: false,
      subheaderEnable: false
    });    
  }
  
  parseData = async (query, menu) => {
    
    const urlIframe = process.env.NEXT_PUBLIC_URL_SORTEO_MUNDIAL + "index.html#/clarin/pronostico-mundial-2026";
    
    let predictionId = query[1] || "";
    this.setTitle(`Pronósticos - Clarin.com`);
    
  
    this.setTemplate("DrawFifaWorldCup");
    this.setData({
      title: `El simulador del Mundial 2026`,
      iframe: predictionId ? `${urlIframe}/${predictionId}` : urlIframe,
      height: "100%",
    });
  }

}